'use strict';

// The actually source is written using es6 and can be found in `/src`.
// This points to the es5 transpiled source.
require('./es5/index.js');


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/filter/index.js